import React from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Typography
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const RECURRENCE_OPTIONS = [
  { value: "monthly", label: "Mensal" },
  { value: "bimonthly", label: "Bimestral" },
  { value: "quarterly", label: "Trimestral" },
  { value: "semester", label: "Semestral" },
  { value: "yearly", label: "Anual" }
];

function BoolSelect({ id, label, value, onChange }) {
  const strVal = value === true ? "true" : "false";
  return (
    <FormControl variant="outlined" fullWidth margin="dense">
      <InputLabel id={`${id}-label`} shrink>
        {label}
      </InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        label={label}
        value={strVal}
        onChange={(e) => onChange(e.target.value === "true")}
      >
        <MenuItem value="true">{i18n.t("plans.form.enabled")}</MenuItem>
        <MenuItem value="false">{i18n.t("plans.form.disabled")}</MenuItem>
      </Select>
    </FormControl>
  );
}

/**
 * Campos do plano dedicado alinhados à aba Planos (Configurações).
 */
export default function DedicatedPlanFields({ planForm, setPlanForm, companyId }) {
  const set = (patch) => setPlanForm((p) => ({ ...p, ...patch }));

  return (
    <Grid spacing={1} container>
      <Grid xs={12} item>
        <Typography variant="caption" color="textSecondary" display="block">
          Nome fixo do plano: <code>PlanEmpresa({companyId})</code> (não editável)
        </Typography>
      </Grid>

      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-isPublic"
          label={i18n.t("plans.form.public")}
          value={planForm.isPublic}
          onChange={(v) => set({ isPublic: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-trial"
          label="Trial"
          value={planForm.trial}
          onChange={(v) => set({ trial: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <TextField
          label={i18n.t("plans.form.trialDays")}
          type="number"
          variant="outlined"
          margin="dense"
          fullWidth
          inputProps={{ min: 1 }}
          disabled={!planForm.trial}
          value={planForm.trialDays}
          onChange={(e) => set({ trialDays: e.target.value })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <FormControl variant="outlined" fullWidth margin="dense">
          <InputLabel shrink id="dedicated-recurrence-label">
            Recorrência (plano)
          </InputLabel>
          <Select
            labelId="dedicated-recurrence-label"
            id="dedicated-recurrence"
            label="Recorrência (plano)"
            value={planForm.recurrence}
            onChange={(e) => set({ recurrence: e.target.value })}
          >
            {RECURRENCE_OPTIONS.map((o) => (
              <MenuItem key={o.value} value={o.value}>
                {o.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid xs={12} sm={4} md={2} item>
        <TextField
          label={i18n.t("plans.form.users")}
          type="number"
          variant="outlined"
          margin="dense"
          fullWidth
          value={planForm.users}
          onChange={(e) => set({ users: e.target.value })}
        />
      </Grid>
      <Grid xs={12} sm={4} md={2} item>
        <TextField
          label={i18n.t("plans.form.connections")}
          type="number"
          variant="outlined"
          margin="dense"
          fullWidth
          value={planForm.connections}
          onChange={(e) => set({ connections: e.target.value })}
        />
      </Grid>
      <Grid xs={12} sm={4} md={2} item>
        <TextField
          label="Filas"
          type="number"
          variant="outlined"
          margin="dense"
          fullWidth
          value={planForm.queues}
          onChange={(e) => set({ queues: e.target.value })}
        />
      </Grid>
      <Grid xs={12} sm={4} md={2} item>
        <TextField
          label="Valor"
          variant="outlined"
          margin="dense"
          fullWidth
          value={planForm.amount}
          onChange={(e) => set({ amount: e.target.value })}
        />
      </Grid>

      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-useWhatsapp"
          label="Whatsapp"
          value={planForm.useWhatsapp}
          onChange={(v) => set({ useWhatsapp: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-useWhatsappOfficial"
          label="Whatsapp Oficial"
          value={planForm.useWhatsappOfficial}
          onChange={(v) => set({ useWhatsappOfficial: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-useWhatsMeow"
          label={i18n.t("plans.form.whatsappMeow")}
          value={planForm.useWhatsMeow}
          onChange={(v) => set({ useWhatsMeow: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-useFacebook"
          label="Facebook"
          value={planForm.useFacebook}
          onChange={(v) => set({ useFacebook: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-useInstagram"
          label="Instagram"
          value={planForm.useInstagram}
          onChange={(v) => set({ useInstagram: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-useCampaigns"
          label={i18n.t("plans.form.campaigns")}
          value={planForm.useCampaigns}
          onChange={(v) => set({ useCampaigns: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-useSchedules"
          label={i18n.t("plans.form.schedules")}
          value={planForm.useSchedules}
          onChange={(v) => set({ useSchedules: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-useInternalChat"
          label="Chat Interno"
          value={planForm.useInternalChat}
          onChange={(v) => set({ useInternalChat: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-useExternalApi"
          label="API Externa"
          value={planForm.useExternalApi}
          onChange={(v) => set({ useExternalApi: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-useKanban"
          label="Kanban"
          value={planForm.useKanban}
          onChange={(v) => set({ useKanban: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-useOpenAi"
          label="Talk.Ai"
          value={planForm.useOpenAi}
          onChange={(v) => set({ useOpenAi: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-useIntegrations"
          label="Integrações"
          value={planForm.useIntegrations}
          onChange={(v) => set({ useIntegrations: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-useConecthub360"
          label={i18n.t("plans.form.conecthub360")}
          value={planForm.useConecthub360}
          onChange={(v) => set({ useConecthub360: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-wavoip"
          label="Wavoip"
          value={planForm.wavoip}
          onChange={(v) => set({ wavoip: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-useGroupManagement"
          label={i18n.t("plans.form.groupManagement")}
          value={planForm.useGroupManagement}
          onChange={(v) => set({ useGroupManagement: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-usePhraseListFlow"
          label={i18n.t("plans.form.phraseListFlow")}
          value={planForm.usePhraseListFlow}
          onChange={(v) => set({ usePhraseListFlow: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-useConversationFlow"
          label={i18n.t("plans.form.conversationFlow")}
          value={planForm.useConversationFlow}
          onChange={(v) => set({ useConversationFlow: v })}
        />
      </Grid>
      <Grid xs={12} sm={6} md={2} item>
        <BoolSelect
          id="dedicated-useFollowUp"
          label={i18n.t("plans.form.followUpFlow")}
          value={planForm.useFollowUp}
          onChange={(v) => set({ useFollowUp: v })}
        />
      </Grid>

      <Grid xs={12} sm={6} md={2} item>
        <TextField
          label="Disco (GB)"
          type="number"
          variant="outlined"
          margin="dense"
          fullWidth
          inputProps={{ min: 0, step: 0.1 }}
          value={planForm.diskQuotaGb}
          onChange={(e) => set({ diskQuotaGb: e.target.value })}
          helperText="Quota de disco em GB (padrão: 2 GB)"
        />
      </Grid>
      <Grid xs={12} sm={6} md={4} item style={{ display: "flex", alignItems: "center" }}>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={!!planForm.checkDiskQuota}
              onChange={(e) => set({ checkDiskQuota: e.target.checked })}
            />
          }
          label="Bloqueio de mídia (verificar quota antes de uploads)"
        />
      </Grid>
    </Grid>
  );
}
